import request from 'services/axios'

export const getTransactions = async ({
    cursor,
    q,
    date,
    box_type,
    box_id,
    kind,
    date_from,
    date_to,
}: IDashboardTransactionsParams) => {
    const { data }: { data: IDashboardTransactions } = await request.get(
        '/api/v1/payment/transactions/',
        {
            params: {
                cursor,
                ...(q ? { q } : {}),
                ...(date ? { date } : {}),
                // The server refuses a `box_id` without its `box_type`.
                ...(box_type ? { box_type } : {}),
                ...(box_type && box_id ? { box_id } : {}),
                ...(kind ? { kind } : {}),
                ...(date_from ? { date_from } : {}),
                ...(date_to ? { date_to } : {}),
            },
        }
    )
    return data
}
